import React from 'react';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import {Get } from 'VesselMaster/vesselMaster.hooks';
import env from 'environment_system/env_system';
import { Button } from 'reactstrap';

export const GrantEditAccess = ({ handleOfflineEditAccess, VesselData, onClose }:any) => {
  /**
   * Check if internet available or not
   */
  const { data: InternetStatus, isLoading } = useQuery(
    [queryKeyes.vessel.CheckInternet.key,],
    async () => {
      return await Get(queryKeyes.vessel.CheckInternet.url());
    },
    {
      staleTime: 0,
      enabled: env.offlineCopy === true,
      cacheTime: 0,
      refetchOnMount: 'always',
    }
  );

  if (isLoading) {
    return <div className="p-4 text-center">Checking internet connection...</div>;
  }

  return (
    <div className="p-4 text-center space-y-4">
      {InternetStatus.internet_availability === false ? (
        <>
          <p className="text-lg font-medium">Please connect to the internet.</p>
          <Button 
            color="primary"
            onClick={onClose}>OK</Button>
        </>
      ) : (
        <>
          <p className="text-lg font-medium text-start">
            1. You will not be able to create or submit new reports until the requested report has been edited and closed by the administrator. <br/>
            2. Ensure all reports are completed, submitted, and synced with the server. Any pending or unsynced reports will be discarded. <br/>
            3. Please send an email immediately with the details of the edits required. Include the report event, date and time, and the specific data to be edited. <br/>
            4. To cancel an edit request, contact us via email as soon as possible.<br/>
            5. Once the edit is completed, you will need to submit a new request if you wish to cancel or revert the changes.<br/>
        </p>
          <div className="flex justify-center gap-4">
            <Button   
                type="button"
                color="danger"
                className="mr-2 mt-3 popover_btn"
                onClick={() => {
                  handleOfflineEditAccess(VesselData?.offline_edit_status)
                  onClose();
                }}
            >
                Yes, I agree
            </Button>
            <Button
                type="button"
                color="primary"
                className="mt-3"
              onClick={onClose}
            >
                No
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
